<template>
  <div v-loading="pageLoading">
    <ContactAndProduct ref="ContactAndProduct" @chooseProductChanged="chooseProductChanged"></ContactAndProduct>

    <el-divider content-position="left">报修信息</el-divider>
    <el-form class="rule-form" :model="maintainIncident" :rules="rules" ref="ruleForm" label-width="100px" label-position="left" :hide-required-asterisk="true">
      <el-form-item label="不良发生日期" prop="failureDate">
        <el-date-picker
            v-model="maintainIncident.failureDate"
            align="right"
            :editable="false"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 100%;"
            :picker-options="previousPicker">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="期望上门日期" prop="expectDate">
        <el-date-picker
            v-model="maintainIncident.expectDate"
            align="right"
            :editable="false"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 100%;"
            :picker-options="expectDatePicker">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="购买日期" prop="buyDate">
        <el-date-picker
            v-model="maintainIncident.buyDate"
            align="right"
            :editable="false"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选填"
            style="width: 100%;"
            :picker-options="previousPicker">
        </el-date-picker>
      </el-form-item>
      <div v-if="'智能开关' == product.series">
        <el-form-item label="开关数量" prop="productCount">
          <el-input v-model="maintainIncident.productCount" placeholder="选填"></el-input>
        </el-form-item>
      </div>
      <el-form-item label="S/N编码">
        <el-input v-model="maintainIncident.snCode" placeholder="选填"></el-input>
      </el-form-item>
      <el-form-item label="故障类别" prop="failureType">
        <el-input  v-model="maintainIncident.failureType" placeholder="请选择" style="width: 100%" @focus="drawer = true"  :readonly="true"></el-input>
        <el-drawer
            title="故障类别选择"
            v-if="drawer"
            :visible.sync="drawer"
            :direction="direction"
            :size="size">
          <el-radio :label="f" v-model="maintainIncident.failureType" v-for="(f,i) in failureList" :key="i" class="fail-radio">{{f}}</el-radio>
        </el-drawer>
      </el-form-item>
      <el-form-item label="故障描述" prop="failureDesc">
        <el-input
            type="textarea"
            :rows="4"
            placeholder="请描述具体故障.."
            v-model="maintainIncident.failureDesc">
        </el-input>
      </el-form-item>
      <div class="upload-tip">请提供故障照片</div>
      <el-upload
          :action="this.$uploadURL"
          ref="upload"
          :with-credentials="false"
          :multiple="true"
          list-type="picture-card"
          :on-error="uploadError"
          :on-success="handleAvatarSuccess">
        <i slot="default" class="el-icon-plus"></i>
<!--        <div slot="file" slot-scope="{file}" @click="clickIn" v-clickout="clickOut">-->
        <div slot="file" slot-scope="{file}" @click="clickIn">
          <el-progress v-show="file.percentage!=100" type="circle" :percentage="showfilepercentage(file.percentage)"></el-progress>
          <img
              class="el-upload-list__item-thumbnail"
              :src="file.url" alt=""
          >
          <span class="el-upload-list__item-actions">
                <span
                    v-if="!disabled"
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
        </div>
      </el-upload>
    </el-form>
    <el-divider class="info-divider"></el-divider>
    <el-button class="submit-btn" type="primary" @click="submit('ruleForm')">预约维修</el-button>
  </div>
</template>

<script>
    import ContactAndProduct from "./ContactAndProduct"

    export default {
        name: "MaintainInfo",
        components:{
            ContactAndProduct
        },
        data(){
            return{
                myProductDivWidth: document.documentElement.clientWidth - 68,
                contact: {},
                product: {},
                pageLoading: false,
                previousPicker: {
                    disabledDate: (time) => {
                        // 设置可选择的日期为今天之前
                        const curDate = (new Date()).getTime();
                        const day = 24 * 3600 * 1000;
                        const dateRegion = curDate + day;
                        return time.getTime() > dateRegion - 8.64e7
                    }
                },
                expectDatePicker: {
                    disabledDate: (time) => {
                        // 设置可选择的日期为今天之后的一个月内
                        const curDate = (new Date()).getTime();
                        const day = 30 * 24 * 3600 * 1000;
                        const dateRegion = curDate + day;
                        return time.getTime() < Date.now() - 8.64e7 ||
                            time.getTime() > dateRegion
                    }
                },
                rules: {
                    failureDate: [
                        { type: 'string', required: true, message: '请选择不良发生日期', trigger: 'change' }
                    ],
                    expectDate: [
                        { type: 'string', required: true, message: '请选择期望上门日期', trigger: 'change' }
                    ],
                    failureType: [
                        { required: true, message: '请选择故障类别', trigger: 'change' }
                    ]
                },

                drawer: false,
                direction: 'btt',
                size: '50%',
                failureList: ['请先选择产品'],
                failureList1: [
                    '密码按键不灵敏','指纹不能识别','不通电',
                    '密码验证开锁失效','指纹验证开锁失效','钥匙开锁失效',
                    '门把手脱落','锁自动打开','自动报警',
                    '滑盖紧','滑盖松','其他'
                ],
                failureList12: [
                    '按键没反应','开关灯闪烁','无法联网',
                    '关灯后灯微亮','APP控制问题','设备经常离线',
                    '其他'
                ],
                failureList13: [
                    '灯不亮','升降异常','电机异响',
                    '外壳破损','遥控器失灵','钢绳断',
                ],
                failureList14: [
                    '电机不转','电机异响','轨道卡滞',
                    '电机配对异常','网络连接异常','遥控器失灵',
                    '其他'
                ],
                failureList2: [
                    '灯不亮','灯亮度暗','肉眼可见灯体闪烁',
                    '调光变色失效','电流异响','外壳/灯罩破损',
                    '内有异物','其他'
                ],
                failureList3: [
                    '不换气','灯不亮','不出热风',
                    '有异味','出风管破损','安装脱落',
                    '电机不转','开关问题','按钮功能与标识错位','其他'
                ],

                disabled: true,

                // 维修工单
                maintainIncident: {
                    contactId: '',       // 联系人id
                    productType: '',     // 产品类型
                    productSeries: '',   // 产品系列
                    productModel: '',    // 产品型号
                    productCount: '',    // 产品数量
                    existAssetsId: 0,    // 联系人已有资产id
                    existProductId: 0,   // 联系人已有产品id
                    buyDate: '',         // 购买日期
                    failureDate: '',     // 不良发生日期
                    expectDate: '',      // 期望上门日期
                    snCode: '',          // S/N编码
                    failureType: '',     // 故障类别
                    failureDesc: '',     // 故障描述
                    fileUrlList: [],     // 附件
                    openid: '',
                    unionid: '',
                    appid: ''
                }
            }
        },
        watch: {
            product: {
                handler(){
                    this.maintainIncident.failureType = '';
                    switch (this.product.type) {
                        case "智能家居":
                            switch (this.product.series){
                                case "智能锁":
                                    this.failureList = this.failureList1;
                                    break;
                                case "智能开关":
                                    this.failureList = this.failureList12;
                                    break;
                                case "晾衣机":
                                    this.failureList = this.failureList13;
                                    break;
                                case "窗帘":
                                    this.failureList = this.failureList14;
                                    break;
                            }
                            break;
                        case "LED":
                            this.failureList = this.failureList2;
                            break;
                        case "生活电器":
                            this.failureList = this.failureList3;
                            break;
                    }
                },
                deep: true
            }
        },
        methods:{
            setMyProducts(myProducts){
                this.$refs.ContactAndProduct.setMyProducts(myProducts);
            },
            chooseProductChanged(){
                this.product = this.$refs.ContactAndProduct.product;
                this.product.type = '智能家居' // 强制更改为智能家居
                // console.log(this.product);
                this.maintainIncident.existAssetsId = this.$refs.ContactAndProduct.existAssetsId;
                this.maintainIncident.existProductId = this.$refs.ContactAndProduct.existProductId;
            },
            getImgUrl(icon){
                return require("@/assets/"+icon);
            },

            handleAvatarSuccess(response){
                this.maintainIncident.fileUrlList.push(response);
            },
            handleRemove(file) {
                this.maintainIncident.fileUrlList.splice(this.maintainIncident.fileUrlList.indexOf(file.response),1);
                this.$refs.upload.handleRemove(file);
            },
            uploadError(error) {
                console.log("error",error);
            },
            showfilepercentage(per){
                return Math.floor(per);
            },
            clickIn() {
                this.disabled = false;
            },
            clickOut() {
                this.disabled = true;
            },
            // 提交
            submit(formName){
                if(JSON.stringify(this.contact)=='{}'){
                    this.contact = this.$refs.ContactAndProduct.$refs.Contact.contact;
                }
                if(JSON.stringify(this.product)=='{}'||JSON.stringify(this.contact)=='{}'){
                    this.$message({
                        type: 'warning',
                        message: '请选择联系人产品!',
                        offset: 60
                    });
                    return
                }
                if(this.maintainIncident.fileUrlList.length==0){
                  this.$message({
                      type: 'warning',
                      message: '请提供： 完工照片、条码照片、用户确认照片!',
                      offset: 60
                  });
                  return
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.pageLoading = true;
                        this.maintainIncident.contactId = this.contact.id;
                        this.maintainIncident.productType = '智能家居';
                        this.maintainIncident.productSeries = this.product.series;
                        this.maintainIncident.productModel = this.product.model;
                        this.maintainIncident.openid = window.localStorage.getItem("fastopenid");
                        this.maintainIncident.appid = window.localStorage.getItem("fastappid");
                        this.maintainIncident.unionid = window.localStorage.getItem("fastunionid");
                        console.log("maintainIncident:",this.maintainIncident);
                        this.$axios.post(this.$baseURL + `/incident/maintain`,this.$qs.stringify(this.maintainIncident))
                            .then(()=> {
                                console.log("报单成功！");
                                this.$confirm('您已提交成功，我们会尽快处理！', '', {
                                    confirmButtonText: '确定',
                                    showCancelButton: false,
                                    type: 'success',
                                    showClose: false,
                                    customClass: 'message-logout'
                                }).then(() => {
                                    // 提交成功点击确定，刷新页面
                                    console.log("refresh");
                                    this.$router.push({
                                        name:"Auth",
                                    })
                                }).catch(() => {
                                    // DO NOTHING
                                });
                                this.pageLoading = false;
                            })
                            .catch(error=> {
                                console.log(error);
                                this.$message({
                                    type: 'warning',
                                    message: '提交失败，请重试或联系客服',
                                    offset: 60
                                });
                                this.pageLoading = false;
                            });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        },
        activated() {
            // 联系地址后，返回页面时触发
            this.contact = this.$refs.ContactAndProduct.contact;
        }
    }
</script>

<style scoped>
  .rule-form {
    padding: 0px 10px;
    font-size: 14px;
  }
  .fail-radio {
    float: left;
    width: 100%;
    text-align: left;
    margin-left: 20px;
    margin-bottom: 20px;
  }
</style>
